module.exports = __webpack_public_path__ + "static/Iphone 11 Screen1-affa77da6e2c10d31b41716553c08d0c.png";